import React from 'react';
import { Badge, Progress } from 'reactstrap';
import {
	_capitalizeText,
	_formatNumber,
	_slugifyText
} from '../../helpers/utils';

export const subscriptionPlans = [
	/*{
		id: 'basic',
		name: 'Basic',
		pricePerMonth:14.99,
		pricePerYear:240,
		billingFrequency:'month',
		billingFrequencyMonths:12,
		description:'Cancel Anytime',
		totalAtCheckout:14.99,
		freeTrial : true,
		contactUs : false,
		stripeProductId: process.env.NODE_ENV === "development" ? 'price_1HZi3xG44QC64PsROMcvDFxz' : 'price_1HZi0JG44QC64PsRACC9qKor',
		taxCode: process.env.NODE_ENV === "development" ? 'txr_1HPuUwG44QC64PsRi91xssbx' : 'txr_1HCVNJG44QC64PsRdrtshCba',
		users:['Individuals'],
		checkTitle: '7-Day Free Trial',
		dataCredits : 0
	},
	{
		id: 'advanced',
		name: 'Advanced',
		pricePerMonth:49,
		pricePerYear:360,
		billingFrequency:'month',
		billingFrequencyMonths:1,
		description:'Cancel Anytime',
		totalAtCheckout:49,
		freeTrial : true,
		contactUs : false,
		stripeProductId: process.env.NODE_ENV === "development" ? 'price_1I4X7xG44QC64PsRJfBpWfQi' : 'price_1I5u44G44QC64PsRZq0J3cjy',
		taxCode: process.env.NODE_ENV === "development" ? 'txr_1HPuUwG44QC64PsRi91xssbx' : 'txr_1HCVNJG44QC64PsRdrtshCba',
		users:['Individuals'],
		checkTitle: '7-Day Free Trial',
		dataCredits : 10
	},
	{
		id: 'complete',
		name: 'Complete',
		pricePerMonth:249,
		pricePerYear:360,
		billingFrequency:'month',
		billingFrequencyMonths:1,
		description:'Cancel Anytime',
		totalAtCheckout:249,
		freeTrial : true,
		contactUs : false,
		stripeProductId: process.env.NODE_ENV === "development" ? 'price_1I75VmG44QC64PsRiKWWdjQJ' : 'price_1I75XFG44QC64PsRtPbcXYpV',
		taxCode: process.env.NODE_ENV === "development" ? 'txr_1HPuUwG44QC64PsRi91xssbx' : 'txr_1HCVNJG44QC64PsRdrtshCba',
		users:['Real Estate Brokers', 'CRE Brokers', 'Mortgage & Banking', 'Private Equity', 'Title', 'Legal', 'Developers'],
		checkTitle: '7-Day Free Trial',
		dataCredits : 50
	},*/

	// {
	// 	id: 'resale',
	// 	name: 'Resale',
	// 	pricePerMonth:49,
	// 	pricePerYear:360,
	// 	billingFrequency:'month',
	// 	billingFrequencyMonths:1,
	// 	description:'Cancel Anytime',
	// 	totalAtCheckout:49,
	// 	freeTrial : true,
	// 	contactUs : false,
	// 	canUpgrade : true,
	// 	stripeProductId: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'price_1QFdHpG44QC64PsRcd8jPuET' : 'price_1QFdJYG44QC64PsR68V7PA7J',
	// 	taxCode: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'txr_1HPuUwG44QC64PsRi91xssbx' : 'txr_1HCVNJG44QC64PsRdrtshCba',
	// 	users:['Resale Condos & Co-ops', 'Search Past Sales', 'Market & Price Analysis', 'Monitor Discounts Trends'],
	// 	checkTitle: '7-Day Free Trial',
	// 	dataCredits : 0
	// },
	{
		id: 'broker',
		name: 'Broker Suite',
		pricePerMonth: 49,
		pricePerYear: 360,
		billingFrequency: 'month',
		billingFrequencyMonths: 1,
		description: 'Cancel Anytime',
		totalAtCheckout: 49,
		freeTrial: true,
		contactUs: false,
		canUpgrade: true,
		stripeProductId: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'price_1QkSrNG44QC64PsR136Z9FwQ' : 'price_1QkSqgG44QC64PsRtoLlyImN',
		taxCode: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'txr_1HPuUwG44QC64PsRi91xssbx' : 'txr_1HCVNJG44QC64PsRdrtshCba',
		users: ['Real Estate Agents', 'Marketing Professionals', 'Brokerage Firms'],
		checkTitle: '7-Day Free Trial',
		dataCredits: 0,
		valueProp: 'Generate more leads and close more deals with instant marketing content and tools',
		noData: false,
		subtext: 'Essential toolkit for real estate agents'
	},
	{
		id: 'research-agents',
		name: 'Research Suite for Agents',
		pricePerMonth: 129,
		pricePerYear: 1548,
		billingFrequency: 'month',
		billingFrequencyMonths: 1,
		description: 'Cancel Anytime',
		totalAtCheckout: 129,
		freeTrial: true,
		contactUs: true,
		canUpgrade: true,
		hideOnPricingPage: true,
		stripeProductId: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'price_1SxaPsG44QC64PsR7Svwryzt' : 'price_1SxaNMG44QC64PsRc1qGgiLc',
		taxCode: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'txr_1HPuUwG44QC64PsRi91xssbx' : 'txr_1HCVNJG44QC64PsRdrtshCba',
		users: ['Real Estate Agents', 'Research Teams & Analysts', 'Developers', 'Financial Institutions'],
		checkTitle: '7-Day Free Trial',
		dataCredits: 25,
		startAt: false,
		valueProp: 'Showcase your expertise with in-depth insights into the real estate market',
		subtext: 'Discounted Research Suite for agents'
	},
	{
		id: 'complete',
		altIds: ['complete-199'],
		name: 'Research Suite',
		pricePerMonth: 229,
		pricePerYear: 2748,
		billingFrequency: 'month',
		billingFrequencyMonths: 1,
		description: 'Cancel Anytime',
		totalAtCheckout: 229,
		freeTrial: true,
		contactUs: true,
		canUpgrade: true,
		stripeProductId: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'price_1PsAgJG44QC64PsRwqhK6srS' : 'price_1Ps3qBG44QC64PsRUEJOY67y',
		taxCode: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'txr_1HPuUwG44QC64PsRi91xssbx' : 'txr_1HCVNJG44QC64PsRdrtshCba',
		users: ['Real Estate Agents', 'Research Teams & Analysts', 'Developers', 'Financial Institutions'],
		checkTitle: '7-Day Free Trial',
		dataCredits: 25,
		startAt: false,
		valueProp: 'Showcase your expertise with in-depth insights into the real estate market',
		subtext: '$100 off coupon for NYC brokerages'
	},
	{
		id: 'enterprise',
		name: 'Enterprise',
		pricePerMonth: 9500,
		pricePerYear: 360,
		billingFrequency: 'month',
		billingFrequencyMonths: 1,
		description: 'Contact Us',
		totalAtCheckout: 9500,
		freeTrial: false,
		contactUs: true,
		stripeProductId: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'price_1PsCOoG44QC64PsRSV4ABnck' : 'price_1PsCPXG44QC64PsRgeGXJK6s',
		taxCode: process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local" ? 'txr_1HPuUwG44QC64PsRi91xssbx' : 'txr_1HCVNJG44QC64PsRdrtshCba',
		users: ['Real Estate Brokers', 'CRE Brokers', 'Mortgage & Banking', 'Private Equity', 'Title', 'Legal', 'Developers'],
		hidePrice: false,
		checkTitle: "Tailored To Your Needs",
		dataCredits: 100,
		startAt: true,
		hideChangePlan: true,
		valueProp: "Access custom solutions and Marketproof experts to achieve your firm's  goals",
		subtext: 'Supercharged for real estate teams and firms'

	},

];


export const appFeatures = [
	{
		name: 'AI Generated Research Reports',
		plans: ['basic', 'advanced', 'resale', 'broker', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: '',
		// hide: ["complete", "enterprise"],
		badge: ""
	},
	{
		name: 'AI Generated Social, Email and Post Cards',
		plans: ['basic', 'advanced', 'resale', 'broker', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: '',
		// hide: ["complete", "enterprise"],
		badge: ""
	},
	{
		name: 'AI Assisted Comp, Property and Building Reports',
		plans: ['basic', 'advanced', 'resale', 'broker', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: '',
		// hide: ["complete", "enterprise"],
		badge: ""
	},
	{
		name: 'AI Market Snapshots',
		plans: ['basic', 'advanced', 'resale', 'broker', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: '',
		// hide: ["complete", "enterprise"],
		badge: ""
	},
	{
		name: 'Owner Outreach',
		plans: ['advanced', 'resale', 'complete', 'broker', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'AI-Enhanced Skip Tracing',
		plans: ['advanced', 'resale', 'complete', 'broker', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	// {
	// 	name: 'Building Reports',
	// 	plans: ['basic', 'advanced', 'resale', 'broker'],
	// 	description: '',
	// 	hide: ["complete", "enterprise"],
	// 	badge : ""
	// },
	// {
	// 	name: 'Market Reports',
	// 	plans: ['basic', 'advanced', 'resale', 'broker'],
	// 	description: '',
	// 	hide: ["complete", "enterprise"],
	// 	badge : ""
	// },
	// {
	// 	name: 'Social Media Posts',
	// 	plans: ['basic', 'advanced', 'resale', 'broker'],
	// 	description: '',
	// 	hide: ["complete", "enterprise"],
	// 	badge : ""
	// },
	// {
	// 	name: ' Newsletter Content',
	// 	plans: ['basic', 'advanced', 'resale', 'broker'],
	// 	description: '',
	// 	hide: ["complete", "enterprise"],
	// 	badge : ""
	// },
	// {
	// 	name: 'Post Cards',
	// 	plans: ['basic', 'advanced', 'resale', 'broker'],
	// 	description: '',
	// 	hide: ["complete", "enterprise"],
	// 	badge : ""
	// },
	// 
	// {
	// 	name: 'Everying in Broker Suite',
	// 	plans: ['complete', 'complete-199'],
	// 	description: '',
	// 	hide: ["resale", "broker", "enterprise"],
	// 	badge : "",
	// 	bold: true
	// },
	// {
	// 	name: 'Everying in Complete',
	// 	plans: [ 'enterprise'],
	// 	description: '',
	// 	hide: ["resale", "broker",'complete', 'complete-199', ],
	// 	badge : "",
	// 	bold: true
	// },
	{
		name: 'Daily & Weekly Insider Newsletter (Email)',
		plans: ['basic', 'advanced', 'resale', 'broker', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'New Development Building Search',
		plans: ['advanced', 'resale', 'complete', 'broker', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Resale Condo/Co-op Search',
		plans: ['advanced', 'resale', 'complete', 'broker', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Townhouse, Single & Multi-Family Search',
		plans: ['advanced', 'resale', 'complete', 'broker', 'complete-199', 'research-agents', 'enterprise'],

		description: ''
	},
	// {
	// 	name: 'Weekly Market Update (Email)',
	// 	plans: ['basic', 'advanced', 'resale', 'complete', 'complete-199', 'enterprise'],
	// 	hide: ["marketing"],
	// 	description: ''
	// },


	{
		name: 'Inventory Search (Incl. Shadow and Off-Market Units)',
		plans: ['advanced', 'resale', 'broker', 'complete', 'complete-199', 'research-agents', 'enterprise'],

		description: ''
	},
	{
		name: 'Past Sales Search',
		plans: ['advanced', 'resale', 'broker', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Stacking Plans & Building Analysis',
		plans: ['basic', 'advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Collections & Notifications',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Map Search',
		plans: ['basic', 'advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},

	{
		name: 'New Development Inventory Analysis',
		plans: ['complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Sales Velocity Analysis',
		plans: ['complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Price Trend Analysis',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Discount Analysis',
		plans: ['complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Permits & Filings',
		plans: ['complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	// {
	// 	name: 'Market Snapshot',
	// 	plans: ['basic', 'advanced', 'resale', 'complete', 'complete-199', 'enterprise'],
	// 	hide: ["marketing"],
	// 	description: ''
	// },
	// {
	// 	name: 'Sharing',
	// 	plans: ['basic', 'advanced', 'resale', 'complete', 'complete-199', 'enterprise'],
	// 	description: ''
	// },	

	/*
		{
			name: 'Report Your Buy/Sell Side Contracts',
			plans: ['basic', 'advanced', 'complete', 'complete-199', 'enterprise'],
			description: ''
		},
	
		{
			name: 'Market Activity (Unit Details)',
			plans: ['advanced',  'resale','complete', 'complete-199', 'enterprise'],
			description: ''
		},	
		*/

	{
		name: 'Consumer Lender & Loan Officer Details',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Buyer\'s Attorney and Law Firm Details',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Building Management & Contacts',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},


	{
		name: 'Financial Document Search',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Permit Search',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Buyer & Seller Name Search',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Project Financing & Offering Info',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Energy Use & Environmental Risk',
		plans: ['advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},

	{
		name: 'Sales Agent Analysis',
		plans: ['complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Architec  Analysis',
		plans: ['complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	{
		name: 'Developer Analysis',
		plans: ['complete', 'complete-199', 'research-agents', 'enterprise'],
		description: ''
	},
	/*
		{
			name: 'Rental Buildings',
			plans: ['complete', 'complete-199', 'enterprise'],
			description: ''
		},
	*/


	/*
		{
			name: 'Report Firm\'s Buy/Sell Side Contracts',
			plans: ['enterprise'],
			description: ''
		},
	*/
	{
		name: 'Lenders - Analysis',
		plans: ['enterprise', 'complete', 'complete-199', 'research-agents'],
		description: ''
	},

	{
		name: 'Research & Advisory Services',
		plans: ['enterprise'],
		description: ''
	},
	{
		name: 'Access to Marketproof team',
		plans: ['enterprise'],
		description: ''
	},
	{
		name: 'Custom Reports',
		plans: ['enterprise'],
		description: ''
	},
	// {
	// 	name: 'Priority Support',
	// 	plans: ['enterprise'],
	// 	description: ''
	// },



]

export const dataFeatures = [
	{
		name: 'Data Export (Self-serve)',
		plans: ['basic', 'advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: 'Export building, unit and market activity data for your own use.',
		learn_more: "https://help.marketproof.com/en/articles/4857038-guide-to-exporting-data-on-marketproof-new-development"
	},
	{
		name: 'Pay As You Go Data Credits',
		plans: ['basic', 'advanced', 'resale', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: 'Buy more data credits at anytime if you run out.',
		learn_more: "https://help.marketproof.com/en/articles/4857038-guide-to-exporting-data-on-marketproof-new-development"
	},
	{
		name: 'No Data Credits Inlcuded',
		plans: ['advanced', 'complete', 'complete-199', 'research-agents', 'enterprise'],
		description: 'Data credits allow you to export a varity of data sets for your use.',
		learn_more: "https://help.marketproof.com/en/articles/4857038-guide-to-exporting-data-on-marketproof-new-development"
	},

	{
		name: 'API Access',
		plans: ['enterprise'],
		description: ''
	}

]

export const coreTranslate = {
	"we3-properties": "unit",
	"we3-buildings": "building",
	"we3-activities-3": "activity",
	"we3-transactions": "sale",
	"search-agents": "agent"
}

export const dataExportCreditMap = {
	"building": 4,
	"unit": 50,
	"activity": 50,
	"sale": 15,
	"agent": 75,
	"owner": 75
}

export const maxDownload = (core_name, user) => {

	const { subscriptionPlan, monthlyDataCreditOverride } = user;
	if (user.role.indexOf('admin') >= 0) {
		return 25000;
	}

	let dataCredits = 0;
	let currentPlan = subscriptionPlans.filter(plan => plan.stripeProductId === subscriptionPlan)[0];
	if (!currentPlan) {
		currentPlan = subscriptionPlans.filter(plan => user.role.includes(plan.id) ||
			(plan.altIds && plan.altIds.some(altId => user.role.includes(altId))))[0];
	}

	if (currentPlan && currentPlan.dataCredits) {
		dataCredits = currentPlan.dataCredits
	}



	if (typeof monthlyDataCreditOverride === 'number' && monthlyDataCreditOverride >= 0) {
		dataCredits = monthlyDataCreditOverride;
	}

	// if((user.downloadAccess === 'manual' && (user.role && user.role.indexOf("elliman-agent")<0)) || (user.ssoOrganiztion && user.ssoOrganiztion == "cbwarburg")){
	// 	return (dataExportCreditMap[coreTranslate[core_name]] * dataCredits);
	// }


	let maxDataExportCreditMap = {
		"building": 300,
		"unit": 5000,
		"activity": 2000,
		"sale": 5000,
		"agent": 5000
	}
	// if(user && user.role.indexOf('admin')>=0){
	// 	dataExportCreditMap = {
	// 		"building" : 10000,
	// 		"unit" : 10000,
	// 		"activity" : 10000,
	// 		"sale" : 10000
	// 	}
	// }
	return maxDataExportCreditMap[coreTranslate[core_name]];
}


export const calculateCredits = (core_name, rows, facets, exportType) => {

	let total_records = 0;
	let coreType = exportType && exportType == "owner" ? exportType : coreTranslate[core_name];
	if (facets) {
		if (coreType == "building") {
			if (facets.by_units && facets.by_units.buckets) {
				facets.by_units.buckets.forEach(bucket => {
					if (bucket.count) {
						const multiplier = 1; //(bucket.val + 50) / 50;
						total_records += bucket.count * multiplier;
					}
				})

			}

		} else if (coreType == "unit") {
			if (facets.by_status && facets.by_status.buckets) {
				facets.by_status.buckets.forEach(bucket => {
					if (bucket.count) {
						const multiplier = bucket.val == "shadow" ? 5 : 1;
						total_records += bucket.count * multiplier;
					}
				})

			}
		}
	} else {
		total_records = rows;
	}



	return Math.ceil(total_records / dataExportCreditMap[coreType]);
}

export const costPerCredit = 5;

export const translateCreditToDollars = (credits) => {
	return credits * costPerCredit;
}

export const DataCreditUsageProgress = ({ credit_used, credit_total, maxWidth, label, color, usage }) => {

	let creditAvail = credit_total - credit_used;
	if (creditAvail < 0) creditAvail = 0;

	let progress = parseFloat(((creditAvail) / credit_total) * 100);
	let credit_limit_used = credit_used > credit_total ? credit_total : credit_used;
	let credit_over_limit_used = credit_used > credit_total ? credit_used - credit_total : 0;

	if (usage) {
		return (
			<div className={`dashboard__stat-item`} style={{ maxWidth: maxWidth ? maxWidth : '100%' }} >
				<div className="dashboard__stat">
					<div className={`progress-wrap progress-wrap--big`}>
						<Progress multi>
							<Progress bar value={credit_limit_used ? credit_limit_used : 0} max={credit_total + credit_over_limit_used}>
								<span>{credit_limit_used ? _formatNumber(credit_limit_used) : '0'} of {credit_total > 0 ? _formatNumber(credit_total) : '0'} <span className="small-text light-text" style={{ color: '#FFF' }}>Included</span></span>
							</Progress>
							{credit_over_limit_used > 0 &&
								<Progress bar color="active" value={credit_over_limit_used} max={credit_total + credit_over_limit_used}>
									<span>{_formatNumber(credit_over_limit_used)} <span className="small-text light-text" style={{ color: '#FFF' }}> Purchased</span></span>
								</Progress>
							}
						</Progress>
					</div>
				</div>
			</div>
		);
	}
	return (
		<div className={`dashboard__stat-item`} style={{ maxWidth: maxWidth ? maxWidth : '100%' }} >
			<div className="dashboard__stat">
				<div className={`progress-wrap reverse progress-wrap--middle progress-wrap--${color ? color : 'purple'}-gradient progress-wrap--rounded`}>
					<p className="progress__label" style={{ fontSize: 13 }}><span className="semi-bold-text">{creditAvail > 0 ? _formatNumber(creditAvail) : '0'} of {credit_total > 0 ? _formatNumber(credit_total) : '0'}</span> included credits available</p>
					<Progress value={progress} />
				</div>
			</div>
		</div>
	);

}

export const _isPipelineSubscriber = (user) => {
	return user && user.role && Array.isArray(user.role) && user.role.filter(r => ['pipeline-complete', 'pipeline-basic', 'pipeline-enterprise'].indexOf(r) > -1).length > 0
}

export const _isNewDevSubscriber = (user) => {
	return (user && user.subscriptionPlan && user && user.role && Array.isArray(user.role) && user.role.filter(r => [
		"basic",
		"advanced",
		"complete",
		"resale",
		"broker",
		"complete",
		"complete-199",
		"research-agents",
		"enterprise",
		"admin"
	].indexOf(r) > -1).length > 0) || (user && user.subscriptionPlan && user.subscriptionPlan == "custom-sso")
}